import type { OrgAddress } from '@bb/domain/dist/types';

export type BuildOrgAddressPayload = Pick<
  OrgAddress,
  'address' | 'city' | 'country' | 'line1' | 'line2' | 'province' | 'postalCode'
>;

const canBuildOrgAddress = (address: BuildOrgAddressPayload) => {
  const REQUIRED_FIELDS: (keyof BuildOrgAddressPayload)[] = [
    'city',
    'country',
    'line1',
    'province',
    'postalCode',
  ];

  if (!address) return false;

  return REQUIRED_FIELDS.every(key => Boolean(address[key]));
};

export function buildOrgAddress(
  address: BuildOrgAddressPayload,
  numlines?: undefined,
): [string];
export function buildOrgAddress(
  address: BuildOrgAddressPayload,
  numLines: 1,
): [string];
export function buildOrgAddress(
  address: BuildOrgAddressPayload,
  numLines: 2,
): [string, string];
export function buildOrgAddress(address: BuildOrgAddressPayload, numLines = 1) {
  if (!canBuildOrgAddress(address)) return [address?.address || ''];

  const { line1, line2, city, province, postalCode, country } = {
    ...address,
    province: address.province.toUpperCase(),
    postalCode: address.postalCode.toUpperCase(),
    country: address.country.toUpperCase(),
  };

  if (numLines === 1) {
    const result: [string] = [''];
    result[0] = `${
      line2 ? `${line2} - ` : ''
    }${line1}, ${city}, ${province}, ${postalCode}, ${country}`;
    return result;
  }

  const result: [string, string] = ['', ''];

  result[0] = `${line2 ? `${line2} - ` : ''}${line1},`;
  result[1] = `${city}, ${province}, ${postalCode}, ${country}`;

  return result;
}

export { canBuildOrgAddress };
